import { useMediaQuery } from "@mui/material"

/** Indique si l'utilisateur a demandé à réduire les animations (préférence système) */
export const usePrefersReducedMotion = (): boolean =>
  useMediaQuery("(prefers-reduced-motion: reduce)")
